import { NgOptimizedImage } from '@angular/common';
import { Component, input, output } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { CasinoGameViewModel } from '@frontend/sports/types/components/banners/models';
import { DsCard } from '@frontend/ui/card';

@Component({
    selector: 'ms-banner-games-single-row',
    templateUrl: './banner-games-single-row.component.html',
    styleUrl: './banner-games-single-row.component.scss',
    imports: [ScrollAdapterComponent, NgOptimizedImage, DsCard],
})
export class BannerGamesSingleRowComponent {
    games = input.required<CasinoGameViewModel[]>();
    readonly openGame = output<{ game: CasinoGameViewModel; index: number }>();
}
